// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"28c51af9","732":"1ca368e4","977":"b3c96d8e"}[chunkId] + ".chunk.js";
};